export enum UserStatusLevel {
  Customer,
  Employee
}
